module.exports = __webpack_public_path__ + "img/27.dab0d36d.png";